<script>
import Item from "./TrasladosIncluidosItem.vue";
export default {
  props: {
    trasladosIncluidos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Item,
  },
  data() {
    return {
      cargando: false,
      error: false,
    };
  },
  methods: {
    async procesar({ serviceId, codigoCompaniaAerea, numeroVuelo }) {
      this.cargando = true;
      this.error = false;
      try {
        const data = await this.$parent.getOrUpdateOpciones({
          trasladosGDS: {
            serviceId,
            codigoCompaniaAerea,
            numeroVuelo,
          },
        });
        if (data.error) {
          throw new Error(data.error);
        }
        this.$emit("update", data);
      } catch (e) {
        this.error = e.message;
      }
      this.cargando = false;
    },
  },
};
</script>

<template>
  <section class="trasladosIncluidos" v-if="trasladosIncluidos.length">
    <h3>Datos para su traslado</h3>
    <table class="table table-condensed" aria-hidden="true">
      <tbody>
        <tr>
          <th v-html="'&nbsp;'"></th>
          <th v-html="'D&iacute;a Transfer'"></th>
          <th>Ciudad</th>
          <th title="Compañía">Cia</th>
          <th title="Número de vuelo">Vuelo</th>
        </tr>
        <Item
          v-for="traslado in trasladosIncluidos"
          :key="traslado.idServicioCarga"
          :item="traslado"
          :cargando="cargando"
          @update="procesar"
        />
      </tbody>
    </table>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>
  </section>
</template>

<style lang="scss">
.trasladosIncluidos {
  & {
    margin: 20px 0;
  }
  .alert-danger {
    display: block !important;
    word-wrap: break-word;
  }
}
</style>
